import { useTranslation } from 'next-i18next'
import { useEffect, useMemo, useState } from 'react'
import useLoadEnums from '../../services/enums'
import ServicesClearFilter from './ServicesClearFilter'

export default function ServicesFilter ({
  onCheckedServiceChange,
  data,
  checkedServices,
  companies
}) {
  const { t } = useTranslation(['services'])
  const [showOnPageLoad, setShowOnPageLoad] = useState(false)
  const services = useMemo(() => data?.services || [], [data])
  const [shouldViewMore, setShouldViewMore] = useState(false)
  const { sortAsc } = useLoadEnums(services, 'services', 'enum.')
  const serviceInputs = sortAsc
    .filter(({ name }) => (
      companies.meta?.facets?.services?.buckets?.find(bucket => bucket.key === name)?.doc_count
    ))
    .map(({ id, name, translatedName }) => (
      <div
        className="form-check mt-2"
        key={id}
      >
        <input
          className="form-check-input"
          type="checkbox"
          value={name}
          id={`service${id}`}
          checked={!!checkedServices.find(service => service === name)}
          onChange={(e) => handleInputChange(e, name)}
        />
        <label
          className="form-check-label"
          htmlFor={`service${id}`}
        >
          {translatedName}
        </label>
        {
          !checkedServices.find(serviceInputs => serviceInputs === name) && (
            <span className="badge rounded-pill text-bg-primary badge-sm ms-3">
              {
                companies.meta?.facets?.services?.buckets?.find(bucket => bucket.key === name)?.doc_count
              }
            </span>
          )
        }
      </div>
    ))
  const visibleServiceInputs = useMemo(() => shouldViewMore ? serviceInputs : serviceInputs.slice(0, 7))

  useEffect(() => {
    if (window.innerWidth >= 992) {
      setShowOnPageLoad(true)
    }
  }, [])

  const handleInputChange = (e, id) => {
    const checked = e.target.checked

    if (!checked) {
      onCheckedServiceChange(checkedServices.filter(serviceId => serviceId !== id))

      return
    }

    onCheckedServiceChange([...checkedServices, id])
  }

  return (
    <div className="mt-3">
      <button
        className="text-dark col-auto filter-bar__heading w-100 btn d-flex align-items-center justify-content-between fw-bold px-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseCompatibility"
        aria-expanded="false"
        aria-controls="collapseCompatibility"
      >
        <span>
          {t('browse_all.filter.services', { ns: 'services' })}
          {checkedServices.length > 0 && (
            <span className="fw-normal ms-2 badge text-bg-primary px-2 py-1 rounded-pill">
              {checkedServices.length}
            </span>
          )}
        </span>
        <svg
          viewBox="0 0 10 10"
          xmlns="http://www.w3.org/2000/svg"
          height="14"
          width="14"
        >
          <path
            d="M.5,2.75,4.646,7.1a.5.5,0,0,0,.708,0L9.5,2.75"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </button>
      <div
        className={`${showOnPageLoad ? 'show' : ''} collapse`}
        id="collapseCompatibility"
      >
        {visibleServiceInputs}
        {visibleServiceInputs.length >= 7 &&
          < div className="col-auto p-0">
            {!shouldViewMore && (
              <button
                className="btn btn-link text-start ps-0"
                onClick={() => setShouldViewMore(true)}
              >
                {t('view_more')}
              </button>
            )}
            {shouldViewMore && (
              <button
                className="btn btn-link text-start ps-0"
                onClick={() => setShouldViewMore(false)}
              >
                {t('view_less')}
              </button>
            )}
          </div>
        }
        {checkedServices.length > 0 && (<ServicesClearFilter callback={() => onCheckedServiceChange([])} />)}
      </div>
    </div>
  )
}
